import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// Save cash ledger entry
export const saveCashLedger = async (cashLedgerData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/CashLedger/save`,
      cashLedgerData,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving cash ledger:", error);
    throw error;
  }
};

// Get cash ledger entries with pagination
export const getCashLedgers = async (filter = {}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/CashLedger/get`,
      filter,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting cash ledger entries:", error);
    throw error;
  }
};

// Get cash ledger entry by ID
export const getCashLedgerById = async (cashLedgerId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/api/CashLedger/get-by-id/${cashLedgerId}`,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting cash ledger entry:", error);
    throw error;
  }
};

// Export cash ledger to Excel
export const exportCashLedgerToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/CashLedger/export-to-excel`,
      filter,
      {
        headers: getAuthHeader(),
        responseType: 'blob'
      }
    );
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const fromDateStr = filter.FromDate ? new Date(filter.FromDate).toISOString().slice(0,10).replace(/-/g, '') : 'All';
    const toDateStr = filter.ToDate ? new Date(filter.ToDate).toISOString().slice(0,10).replace(/-/g, '') : 'All';
    link.setAttribute('download', `PettyCashReport_${fromDateStr}_to_${toDateStr}_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting cash ledger to Excel:", error);
    throw error;
  }
};